import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './app.jsx';

import HomeIndex from './containers/landing/';
import UserLogin from './components/login/';
import UserLogout from './components/logout/';
import UserRegister from './components/register/';
import UserProfile from './components/profile/';
import ResetPassword from './components/reset_password/';
import requireAuth from './utils/authenticated';

export default (
    <Route  onUpdate={() => window.scrollTo(0, 0)} path="/" component={App}>
        <IndexRoute component={HomeIndex} />
        <Route path="/login" component={UserLogin} />
        <Route path="/logout" component={UserLogout} />
        <Route path="/register" component={UserRegister} />
        <Route path="/reset" component={ResetPassword} />
        <Route path="/profile" component={UserProfile} onEnter={requireAuth} />
    </Route>

);



// WEBPACK FOOTER //
// ./src/app/routes.jsx